export default "__VITE_ASSET__b827c31a__"